"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeFormatsEnum = exports.OrganizationLocaleDateEnum = exports.UserAuthorizationsTypeEnum = exports.DiscountMethodsEnum = exports.RegistrationValidationStatusEnum = exports.RegistrationWindowStatusEnum = exports.RegistrationConstraintPeriodTypeEnum = exports.SurfacesEnum = exports.SpacePropertiesEnum = exports.ResourceAgesEnum = exports.ResourceTypeEnum = exports.ResourceSubTypeEnum = exports.AmenitiesEnum = exports.SeasonPoolStatusEnum = exports.RolesEnum = exports.ActionSourcePlatformEnum = exports.ActionTypesEnum = exports.DayOfWeekEnum = exports.TeamMemberRoleEnum = exports.TeamMemberStatusEnum = exports.TeamCanJoinEnum = exports.PurchasedResourceStatusEnum = exports.EntryStatusEnum = exports.GroupStatusEnum = exports.CustomerTypeEnum = exports.MembershipStatusEnum = exports.PauseHistoryStatusEnum = exports.MembershipTypeEnum = exports.CustomerInMembershipTypeEnum = exports.ProductSubTypesEnum = exports.LineItemsStatusEnum = exports.InvoiceStatusEnum = exports.ProductTypesEnum = exports.NotificationTypeEnum = exports.CurrencyEnum = exports.AddonTimePeriodEnum = exports.PackageProductsRelationTypeEnum = exports.RequestStatusEnum = exports.ProgramHighlightTypeEnum = exports.PublishingStatusEnum = exports.SportsEnum = exports.ProgramSeasonTypesEnum = exports.ProgramTypeNameEnum = exports.ProgramTypesEnum = exports.LevelOfPlayEnum = exports.GenderEnum = exports.DirectBookingTypesEnum = exports.ResourceNameTypeEnum = exports.PurchasedResourceTypeEnum = exports.EntitlementTermsTypesEnum = void 0;
exports.ErrorKeysEnum = exports.PaginationTypeEnum = exports.TimeUnitsEnum = exports.QuantityOperationsEnum = exports.MonthsEnum = exports.EProductResourceSettingKey = exports.SignWaiverEnum = exports.OrderByEnum = exports.MembershipOrderByPropertyEnum = exports.MembershipFilterByPropertyEnum = exports.PriceFieldEnum = exports.PromiseStatusEnum = exports.ActivityEnum = exports.EmailTemplatesEnum = exports.EComparisonFilter = exports.NotifyMethodEnum = exports.PaymentSettingStatusEnum = exports.EEmailStatus = exports.AddonParentTypeEnum = exports.StripeAccountTypesEnum = exports.FinancialStepEnum = exports.SeasonScheduleStatusEnum = exports.CancellationStatusEnum = exports.ProductPackageLevelEnum = exports.BondDayOfWeekEnum = exports.UpdatePricesTypeEnum = exports.EventStatusEnum = exports.ShiftStatusEnum = exports.PlatformsEnum = void 0;
var EntitlementTermsTypesEnum;
(function (EntitlementTermsTypesEnum) {
    EntitlementTermsTypesEnum["QUESTION"] = "question";
    EntitlementTermsTypesEnum["CITY"] = "city";
    EntitlementTermsTypesEnum["MEMBERSHIP"] = "membership";
})(EntitlementTermsTypesEnum = exports.EntitlementTermsTypesEnum || (exports.EntitlementTermsTypesEnum = {}));
var PurchasedResourceTypeEnum;
(function (PurchasedResourceTypeEnum) {
    PurchasedResourceTypeEnum["MEMBERSHIP"] = "membership";
    PurchasedResourceTypeEnum["PRODUCT"] = "product";
    PurchasedResourceTypeEnum["PROGRAM_SEASON"] = "programSeason";
    PurchasedResourceTypeEnum["LEAGUE_SEASON"] = "leagueSeason";
    PurchasedResourceTypeEnum["SPACE"] = "space";
    PurchasedResourceTypeEnum["EVENT"] = "event";
})(PurchasedResourceTypeEnum = exports.PurchasedResourceTypeEnum || (exports.PurchasedResourceTypeEnum = {}));
var ResourceNameTypeEnum;
(function (ResourceNameTypeEnum) {
    ResourceNameTypeEnum["EVENT"] = "event";
    ResourceNameTypeEnum["VENUE"] = "venue";
    ResourceNameTypeEnum["TEAM"] = "team";
    ResourceNameTypeEnum["LEAGUE"] = "league";
    ResourceNameTypeEnum["USER"] = "user";
    ResourceNameTypeEnum["ORGANIZATION"] = "organization";
    ResourceNameTypeEnum["APP"] = "app";
    ResourceNameTypeEnum["FEED"] = "feed";
    ResourceNameTypeEnum["MATCH"] = "match";
    ResourceNameTypeEnum["ROUND"] = "round";
    ResourceNameTypeEnum["PORTAL"] = "portal";
    ResourceNameTypeEnum["LEAGUE_SEASON"] = "season";
    ResourceNameTypeEnum["TOURNAMENT"] = "tournament";
    ResourceNameTypeEnum["MEMBERSHIP"] = "membership";
    ResourceNameTypeEnum["DIVISION"] = "division";
    ResourceNameTypeEnum["GAMESLOT"] = "gameslot";
    ResourceNameTypeEnum["SPACE"] = "space";
    ResourceNameTypeEnum["RESERVATION"] = "reservation";
    ResourceNameTypeEnum["INVOICE"] = "invoice";
    ResourceNameTypeEnum["CUSTOMER"] = "customer";
    ResourceNameTypeEnum["PACKAGE"] = "package";
    ResourceNameTypeEnum["FACILITY"] = "facility";
    ResourceNameTypeEnum["PROGRAM"] = "program";
    ResourceNameTypeEnum["PROGRAM_SEASON"] = "program_season";
    ResourceNameTypeEnum["PRODUCT"] = "product";
    ResourceNameTypeEnum["GROUP"] = "group";
    ResourceNameTypeEnum["VARIANT"] = "variant";
    ResourceNameTypeEnum["SLOT"] = "slot";
    ResourceNameTypeEnum["ADDON"] = "addon";
    ResourceNameTypeEnum["GOODS"] = "goods";
    ResourceNameTypeEnum["FEE"] = "fee";
    ResourceNameTypeEnum["PAYMENT_METHOD"] = "payment_method";
    ResourceNameTypeEnum["DISCOUNT"] = "discount";
    ResourceNameTypeEnum["ACTIVITY"] = "activity";
    ResourceNameTypeEnum["PROGRAM_TYPE"] = "program_type";
    ResourceNameTypeEnum["TAX"] = "tax";
    ResourceNameTypeEnum["PUNCH_PASS"] = "punch_pass";
    ResourceNameTypeEnum["APPLICATION"] = "application";
    ResourceNameTypeEnum["INSTRUCTOR"] = "instructor";
    ResourceNameTypeEnum["PRICE"] = "price";
})(ResourceNameTypeEnum = exports.ResourceNameTypeEnum || (exports.ResourceNameTypeEnum = {}));
var DirectBookingTypesEnum;
(function (DirectBookingTypesEnum) {
    DirectBookingTypesEnum["DIRECT_FOR_ALL"] = "all";
    DirectBookingTypesEnum["DIRECT_FOR_NONE"] = "none";
    DirectBookingTypesEnum["DIRECT_VETTED_ONLY"] = "vetted_only";
    DirectBookingTypesEnum["NO_SETTING"] = "no_setting";
})(DirectBookingTypesEnum = exports.DirectBookingTypesEnum || (exports.DirectBookingTypesEnum = {}));
var GenderEnum;
(function (GenderEnum) {
    GenderEnum[GenderEnum["OTHER"] = 1] = "OTHER";
    GenderEnum[GenderEnum["MALE"] = 2] = "MALE";
    GenderEnum[GenderEnum["FEMALE"] = 3] = "FEMALE";
})(GenderEnum = exports.GenderEnum || (exports.GenderEnum = {}));
var LevelOfPlayEnum;
(function (LevelOfPlayEnum) {
    LevelOfPlayEnum[LevelOfPlayEnum["BEGINNER"] = 1] = "BEGINNER";
    LevelOfPlayEnum[LevelOfPlayEnum["INTERMEDIATE"] = 2] = "INTERMEDIATE";
    LevelOfPlayEnum[LevelOfPlayEnum["ADVANCED"] = 3] = "ADVANCED";
    LevelOfPlayEnum[LevelOfPlayEnum["SEMIPRO"] = 4] = "SEMIPRO";
    LevelOfPlayEnum[LevelOfPlayEnum["SPECTATOR"] = 5] = "SPECTATOR";
})(LevelOfPlayEnum = exports.LevelOfPlayEnum || (exports.LevelOfPlayEnum = {}));
var ProgramTypesEnum;
(function (ProgramTypesEnum) {
    ProgramTypesEnum[ProgramTypesEnum["LEAGUE"] = 0] = "LEAGUE";
    ProgramTypesEnum[ProgramTypesEnum["TOURNAMENT"] = 1] = "TOURNAMENT";
    ProgramTypesEnum[ProgramTypesEnum["CLASS"] = 2] = "CLASS";
    ProgramTypesEnum[ProgramTypesEnum["CLINIC"] = 3] = "CLINIC";
    ProgramTypesEnum[ProgramTypesEnum["CAMP"] = 4] = "CAMP";
    ProgramTypesEnum[ProgramTypesEnum["LESSON"] = 5] = "LESSON";
    ProgramTypesEnum[ProgramTypesEnum["CLUB_TEAM"] = 6] = "CLUB_TEAM";
})(ProgramTypesEnum = exports.ProgramTypesEnum || (exports.ProgramTypesEnum = {}));
var ProgramTypeNameEnum;
(function (ProgramTypeNameEnum) {
    ProgramTypeNameEnum["LEAGUE"] = "league";
    ProgramTypeNameEnum["TOURNAMENT"] = "tournament";
    ProgramTypeNameEnum["CLASS"] = "class";
    ProgramTypeNameEnum["CLINIC"] = "clinic";
    ProgramTypeNameEnum["CAMP"] = "camp";
    ProgramTypeNameEnum["LESSON"] = "lesson";
    ProgramTypeNameEnum["CLUB_TEAM"] = "clubTeam";
})(ProgramTypeNameEnum = exports.ProgramTypeNameEnum || (exports.ProgramTypeNameEnum = {}));
var ProgramSeasonTypesEnum;
(function (ProgramSeasonTypesEnum) {
    ProgramSeasonTypesEnum[ProgramSeasonTypesEnum["ROUND_ROBIN"] = 1] = "ROUND_ROBIN";
    ProgramSeasonTypesEnum[ProgramSeasonTypesEnum["BRACKETS"] = 2] = "BRACKETS";
    ProgramSeasonTypesEnum[ProgramSeasonTypesEnum["CAMP_CLINIC_CLASS"] = 3] = "CAMP_CLINIC_CLASS";
})(ProgramSeasonTypesEnum = exports.ProgramSeasonTypesEnum || (exports.ProgramSeasonTypesEnum = {}));
var SportsEnum;
(function (SportsEnum) {
    SportsEnum[SportsEnum["SOFTBALL"] = 1] = "SOFTBALL";
    SportsEnum[SportsEnum["BASKETBALL"] = 2] = "BASKETBALL";
    SportsEnum[SportsEnum["FOOTBALL"] = 3] = "FOOTBALL";
    SportsEnum[SportsEnum["SOCCER"] = 4] = "SOCCER";
    SportsEnum[SportsEnum["BOWLING"] = 5] = "BOWLING";
    SportsEnum[SportsEnum["BOCCEBALL"] = 6] = "BOCCEBALL";
    SportsEnum[SportsEnum["CORNHOLE"] = 7] = "CORNHOLE";
    SportsEnum[SportsEnum["DODGEBALL"] = 8] = "DODGEBALL";
    SportsEnum[SportsEnum["FRISBEE"] = 9] = "FRISBEE";
    SportsEnum[SportsEnum["HOCKEY"] = 10] = "HOCKEY";
    SportsEnum[SportsEnum["KICKBALL"] = 11] = "KICKBALL";
    SportsEnum[SportsEnum["LACROSSE"] = 12] = "LACROSSE";
    SportsEnum[SportsEnum["PINGPONG"] = 13] = "PINGPONG";
    SportsEnum[SportsEnum["RUGBY"] = 14] = "RUGBY";
    SportsEnum[SportsEnum["SKEEBALL"] = 15] = "SKEEBALL";
    SportsEnum[SportsEnum["TENNIS"] = 16] = "TENNIS";
    SportsEnum[SportsEnum["VOLLEYBALL"] = 17] = "VOLLEYBALL";
    SportsEnum[SportsEnum["WIFFLEBALL"] = 18] = "WIFFLEBALL";
    SportsEnum[SportsEnum["BADMINTON"] = 19] = "BADMINTON";
    SportsEnum[SportsEnum["FITNESS"] = 20] = "FITNESS";
    SportsEnum[SportsEnum["GOLF"] = 21] = "GOLF";
    SportsEnum[SportsEnum["PILATES"] = 22] = "PILATES";
    SportsEnum[SportsEnum["RUNNING"] = 23] = "RUNNING";
    SportsEnum[SportsEnum["SKIING"] = 24] = "SKIING";
    SportsEnum[SportsEnum["SNOWBOARDING"] = 25] = "SNOWBOARDING";
    SportsEnum[SportsEnum["YOGA"] = 26] = "YOGA";
    SportsEnum[SportsEnum["BROOMBALL"] = 27] = "BROOMBALL";
    SportsEnum[SportsEnum["CRICKET"] = 28] = "CRICKET";
    SportsEnum[SportsEnum["CROSSFIT"] = 29] = "CROSSFIT";
    SportsEnum[SportsEnum["CYCLING"] = 30] = "CYCLING";
    SportsEnum[SportsEnum["FIELD_HOCKEY"] = 31] = "FIELD_HOCKEY";
    SportsEnum[SportsEnum["RACQUETBALL"] = 32] = "RACQUETBALL";
    SportsEnum[SportsEnum["SPINNING"] = 33] = "SPINNING";
    SportsEnum[SportsEnum["SQUASH"] = 34] = "SQUASH";
    SportsEnum[SportsEnum["SURFING"] = 35] = "SURFING";
    SportsEnum[SportsEnum["SWIMMING"] = 36] = "SWIMMING";
    SportsEnum[SportsEnum["WIND_SURFING"] = 37] = "WIND_SURFING";
    SportsEnum[SportsEnum["ADVENTURE"] = 38] = "ADVENTURE";
    SportsEnum[SportsEnum["BOXING"] = 39] = "BOXING";
    SportsEnum[SportsEnum["BASEBALL"] = 40] = "BASEBALL";
    SportsEnum[SportsEnum["DANCE"] = 41] = "DANCE";
    SportsEnum[SportsEnum["KICKBOXING"] = 42] = "KICKBOXING";
    SportsEnum[SportsEnum["MARTIAL_ARTS"] = 43] = "MARTIAL_ARTS";
    SportsEnum[SportsEnum["OUTDOORS"] = 44] = "OUTDOORS";
    SportsEnum[SportsEnum["ROWING"] = 45] = "ROWING";
    SportsEnum[SportsEnum["SAILING"] = 46] = "SAILING";
    SportsEnum[SportsEnum["SUP"] = 47] = "SUP";
    SportsEnum[SportsEnum["TRIATHLON"] = 48] = "TRIATHLON";
    SportsEnum[SportsEnum["HANDBALL"] = 49] = "HANDBALL";
    SportsEnum[SportsEnum["CATCHBALL"] = 50] = "CATCHBALL";
    SportsEnum[SportsEnum["BLITZBALL"] = 51] = "BLITZBALL";
    SportsEnum[SportsEnum["ROLLER_DERBY"] = 52] = "ROLLER_DERBY";
    SportsEnum[SportsEnum["ICE_SKATING"] = 53] = "ICE_SKATING";
    SportsEnum[SportsEnum["PICKLEBALL"] = 54] = "PICKLEBALL";
    SportsEnum[SportsEnum["AXE_THROWING"] = 55] = "AXE_THROWING";
    SportsEnum[SportsEnum["FURSAL"] = 56] = "FURSAL";
    SportsEnum[SportsEnum["BIRTHDAY"] = 57] = "BIRTHDAY";
    SportsEnum[SportsEnum["CORPRATE_EVENTS"] = 58] = "CORPRATE_EVENTS";
    SportsEnum[SportsEnum["CURLING"] = 59] = "CURLING";
    SportsEnum[SportsEnum["OTHER"] = 999] = "OTHER";
})(SportsEnum = exports.SportsEnum || (exports.SportsEnum = {}));
var PublishingStatusEnum;
(function (PublishingStatusEnum) {
    PublishingStatusEnum[PublishingStatusEnum["DRAFT"] = 1] = "DRAFT";
    PublishingStatusEnum[PublishingStatusEnum["PUBLISHED"] = 2] = "PUBLISHED";
    PublishingStatusEnum[PublishingStatusEnum["CLOSED"] = 3] = "CLOSED";
    PublishingStatusEnum[PublishingStatusEnum["CANCELLED"] = 4] = "CANCELLED";
    PublishingStatusEnum[PublishingStatusEnum["ARCHIVE"] = 5] = "ARCHIVE";
    PublishingStatusEnum[PublishingStatusEnum["UNPUBLISHED"] = 6] = "UNPUBLISHED";
})(PublishingStatusEnum = exports.PublishingStatusEnum || (exports.PublishingStatusEnum = {}));
var ProgramHighlightTypeEnum;
(function (ProgramHighlightTypeEnum) {
    ProgramHighlightTypeEnum[ProgramHighlightTypeEnum["OTHER"] = 1] = "OTHER";
    ProgramHighlightTypeEnum[ProgramHighlightTypeEnum["MINAGE"] = 2] = "MINAGE";
    ProgramHighlightTypeEnum[ProgramHighlightTypeEnum["MAXAGE"] = 3] = "MAXAGE";
    ProgramHighlightTypeEnum[ProgramHighlightTypeEnum["GENDER"] = 4] = "GENDER";
    ProgramHighlightTypeEnum[ProgramHighlightTypeEnum["LEVELOFPLAY"] = 5] = "LEVELOFPLAY";
    ProgramHighlightTypeEnum[ProgramHighlightTypeEnum["GAMESSEASON"] = 6] = "GAMESSEASON";
    ProgramHighlightTypeEnum[ProgramHighlightTypeEnum["MINWEEK"] = 7] = "MINWEEK";
    ProgramHighlightTypeEnum[ProgramHighlightTypeEnum["SURFACE"] = 8] = "SURFACE";
    ProgramHighlightTypeEnum[ProgramHighlightTypeEnum["FORMAT"] = 9] = "FORMAT";
    ProgramHighlightTypeEnum[ProgramHighlightTypeEnum["PLAYERS_PER_TEAM"] = 10] = "PLAYERS_PER_TEAM";
    ProgramHighlightTypeEnum[ProgramHighlightTypeEnum["MATCH_LENGTH"] = 12] = "MATCH_LENGTH";
})(ProgramHighlightTypeEnum = exports.ProgramHighlightTypeEnum || (exports.ProgramHighlightTypeEnum = {}));
var RequestStatusEnum;
(function (RequestStatusEnum) {
    RequestStatusEnum[RequestStatusEnum["PENDING"] = 1] = "PENDING";
    RequestStatusEnum[RequestStatusEnum["ACCEPTED"] = 2] = "ACCEPTED";
    RequestStatusEnum[RequestStatusEnum["DECLINED"] = 3] = "DECLINED";
})(RequestStatusEnum = exports.RequestStatusEnum || (exports.RequestStatusEnum = {}));
var PackageProductsRelationTypeEnum;
(function (PackageProductsRelationTypeEnum) {
    PackageProductsRelationTypeEnum["CHILD"] = "child";
    PackageProductsRelationTypeEnum["UPSALE"] = "upsale";
    PackageProductsRelationTypeEnum["PARTICIPANT"] = "participant";
    PackageProductsRelationTypeEnum["EXTRA_PARTICIPANT"] = "extra_participant";
})(PackageProductsRelationTypeEnum = exports.PackageProductsRelationTypeEnum || (exports.PackageProductsRelationTypeEnum = {}));
var AddonTimePeriodEnum;
(function (AddonTimePeriodEnum) {
    AddonTimePeriodEnum["FULL"] = "full";
    AddonTimePeriodEnum["SESSION"] = "session";
    AddonTimePeriodEnum["EVENT"] = "event";
})(AddonTimePeriodEnum = exports.AddonTimePeriodEnum || (exports.AddonTimePeriodEnum = {}));
var CurrencyEnum;
(function (CurrencyEnum) {
    CurrencyEnum["USD"] = "USD";
    CurrencyEnum["CAD"] = "CAD";
})(CurrencyEnum = exports.CurrencyEnum || (exports.CurrencyEnum = {}));
var NotificationTypeEnum;
(function (NotificationTypeEnum) {
    NotificationTypeEnum["BOOKING_CONFIRMED_STUFF"] = "booking_confirmed_stuff";
    NotificationTypeEnum["BOOKING_CHANGED_STUFF"] = "booking_changed_stuff";
    NotificationTypeEnum["BOOKING_DELETED_STUFF"] = "booking_deleted_stuff";
    NotificationTypeEnum["FINANCE_UPDATES_STUFF"] = "finance_updates_stuff";
})(NotificationTypeEnum = exports.NotificationTypeEnum || (exports.NotificationTypeEnum = {}));
var ProductTypesEnum;
(function (ProductTypesEnum) {
    ProductTypesEnum["RESERVATION"] = "reservation";
    ProductTypesEnum["REGISTRATION"] = "registration";
    ProductTypesEnum["MEMBERSHIP"] = "membership";
    ProductTypesEnum["GOODS"] = "goods";
    ProductTypesEnum["PACKAGE"] = "package";
    //financial data
    ProductTypesEnum["REFUND_COMPENSATION"] = "refund";
    ProductTypesEnum["CASH_OVER_SHORT"] = "cash_over_short";
    ProductTypesEnum["PETTY_CASH"] = "petty_cash";
    // to be unified with registration later on :
    ProductTypesEnum["LEAGUE_REGISTRATION"] = "league_registration";
    ProductTypesEnum["TAX"] = "tax";
    ProductTypesEnum["EXTRA_PARTICIPANT"] = "extra_participant";
    ProductTypesEnum["PARTICIPANT"] = "participant";
})(ProductTypesEnum = exports.ProductTypesEnum || (exports.ProductTypesEnum = {}));
var InvoiceStatusEnum;
(function (InvoiceStatusEnum) {
    InvoiceStatusEnum["ACTIVE"] = "active";
    InvoiceStatusEnum["WAITING_ADMIN"] = "waitingAdmin";
    InvoiceStatusEnum["WAITING_CLIENT"] = "waitingClient";
    InvoiceStatusEnum["CANCELED"] = "canceled";
    InvoiceStatusEnum["DRAFT"] = "draft";
})(InvoiceStatusEnum = exports.InvoiceStatusEnum || (exports.InvoiceStatusEnum = {}));
var LineItemsStatusEnum;
(function (LineItemsStatusEnum) {
    LineItemsStatusEnum["USER_PRODUCT"] = "UserProduct";
    LineItemsStatusEnum["RENTAL_PRODUCT"] = "RentalProduct";
})(LineItemsStatusEnum = exports.LineItemsStatusEnum || (exports.LineItemsStatusEnum = {}));
var ProductSubTypesEnum;
(function (ProductSubTypesEnum) {
    // league season registartion type
    ProductSubTypesEnum["SEASON_INDIVIDUAL"] = "season_individual";
    ProductSubTypesEnum["SEASON_TEAM"] = "season_team";
    ProductSubTypesEnum["SEASON_PER_PLAYER"] = "season_per_player";
    ProductSubTypesEnum["GROUP_RENTAL"] = "group_rental";
    ProductSubTypesEnum["PER_PARTICIPANT_RENTAL"] = "per_participant_rental";
    ProductSubTypesEnum["RENTAL"] = "rental";
})(ProductSubTypesEnum = exports.ProductSubTypesEnum || (exports.ProductSubTypesEnum = {}));
var CustomerInMembershipTypeEnum;
(function (CustomerInMembershipTypeEnum) {
    CustomerInMembershipTypeEnum["INDIVIDUAL"] = "individual";
    CustomerInMembershipTypeEnum["FAMILY"] = "family";
    CustomerInMembershipTypeEnum["ORGANIZATION"] = "organization";
})(CustomerInMembershipTypeEnum = exports.CustomerInMembershipTypeEnum || (exports.CustomerInMembershipTypeEnum = {}));
var MembershipTypeEnum;
(function (MembershipTypeEnum) {
    MembershipTypeEnum["FIXED"] = "fix_membership";
    MembershipTypeEnum["ROLLING"] = "rolling_membership";
})(MembershipTypeEnum = exports.MembershipTypeEnum || (exports.MembershipTypeEnum = {}));
var PauseHistoryStatusEnum;
(function (PauseHistoryStatusEnum) {
    PauseHistoryStatusEnum["PAUSED"] = "paused";
    PauseHistoryStatusEnum["RESUMED"] = "resumed";
    PauseHistoryStatusEnum["PENDING"] = "pending";
    PauseHistoryStatusEnum["CANCELLED"] = "cancelled";
})(PauseHistoryStatusEnum = exports.PauseHistoryStatusEnum || (exports.PauseHistoryStatusEnum = {}));
var MembershipStatusEnum;
(function (MembershipStatusEnum) {
    MembershipStatusEnum["ACTIVE"] = "active";
    MembershipStatusEnum["ACTIVE_CANCELLED"] = "active_cancelled";
    MembershipStatusEnum["PAUSED_CANCELLED"] = "paused_cancelled";
    MembershipStatusEnum["CANCELLED"] = "cancelled";
    MembershipStatusEnum["EXPIRED"] = "expired";
    MembershipStatusEnum["PAUSED"] = "paused";
    MembershipStatusEnum["PAUSE_PENDING"] = "pause_pending";
    MembershipStatusEnum["PENDING"] = "pending";
})(MembershipStatusEnum = exports.MembershipStatusEnum || (exports.MembershipStatusEnum = {}));
var CustomerTypeEnum;
(function (CustomerTypeEnum) {
    CustomerTypeEnum["USER"] = "user";
    CustomerTypeEnum["FAMILY"] = "family";
    CustomerTypeEnum["ORGANIZATION"] = "organization";
})(CustomerTypeEnum = exports.CustomerTypeEnum || (exports.CustomerTypeEnum = {}));
var GroupStatusEnum;
(function (GroupStatusEnum) {
    GroupStatusEnum[GroupStatusEnum["ACTIVE"] = 1] = "ACTIVE";
    GroupStatusEnum[GroupStatusEnum["INACTIVE"] = 2] = "INACTIVE";
    GroupStatusEnum[GroupStatusEnum["DRAFT"] = 3] = "DRAFT";
})(GroupStatusEnum = exports.GroupStatusEnum || (exports.GroupStatusEnum = {}));
var EntryStatusEnum;
(function (EntryStatusEnum) {
    EntryStatusEnum[EntryStatusEnum["ENTERED"] = 1] = "ENTERED";
    EntryStatusEnum[EntryStatusEnum["NOT_ENTERED"] = 2] = "NOT_ENTERED";
    EntryStatusEnum[EntryStatusEnum["CANCELED"] = 3] = "CANCELED";
    EntryStatusEnum[EntryStatusEnum["RETRO_REGISTERED"] = 4] = "RETRO_REGISTERED";
})(EntryStatusEnum = exports.EntryStatusEnum || (exports.EntryStatusEnum = {}));
var PurchasedResourceStatusEnum;
(function (PurchasedResourceStatusEnum) {
    PurchasedResourceStatusEnum[PurchasedResourceStatusEnum["ACTIVE"] = 1] = "ACTIVE";
    PurchasedResourceStatusEnum[PurchasedResourceStatusEnum["MOVED"] = 2] = "MOVED";
    PurchasedResourceStatusEnum[PurchasedResourceStatusEnum["CANCELED"] = 3] = "CANCELED";
})(PurchasedResourceStatusEnum = exports.PurchasedResourceStatusEnum || (exports.PurchasedResourceStatusEnum = {}));
var TeamCanJoinEnum;
(function (TeamCanJoinEnum) {
    TeamCanJoinEnum["ANYONE"] = "anyone";
    TeamCanJoinEnum["BY_INVITE"] = "byInvite";
    TeamCanJoinEnum["CAPTAIN_APPROVAL"] = "captainApproval";
})(TeamCanJoinEnum = exports.TeamCanJoinEnum || (exports.TeamCanJoinEnum = {}));
var TeamMemberStatusEnum;
(function (TeamMemberStatusEnum) {
    TeamMemberStatusEnum[TeamMemberStatusEnum["PENDING"] = 1] = "PENDING";
    TeamMemberStatusEnum[TeamMemberStatusEnum["ACTIVE"] = 2] = "ACTIVE";
    TeamMemberStatusEnum[TeamMemberStatusEnum["DECLINED"] = 3] = "DECLINED";
    TeamMemberStatusEnum[TeamMemberStatusEnum["SUSPENDED"] = 4] = "SUSPENDED";
    TeamMemberStatusEnum[TeamMemberStatusEnum["INACTIVE"] = 5] = "INACTIVE";
    TeamMemberStatusEnum[TeamMemberStatusEnum["INVITED"] = 6] = "INVITED";
})(TeamMemberStatusEnum = exports.TeamMemberStatusEnum || (exports.TeamMemberStatusEnum = {}));
var TeamMemberRoleEnum;
(function (TeamMemberRoleEnum) {
    TeamMemberRoleEnum[TeamMemberRoleEnum["NULL"] = null] = "NULL";
    TeamMemberRoleEnum[TeamMemberRoleEnum["ADMIN"] = 1] = "ADMIN";
})(TeamMemberRoleEnum = exports.TeamMemberRoleEnum || (exports.TeamMemberRoleEnum = {}));
//	Not the bad way of numbering
var DayOfWeekEnum;
(function (DayOfWeekEnum) {
    DayOfWeekEnum[DayOfWeekEnum["SUNDAY"] = 0] = "SUNDAY";
    DayOfWeekEnum[DayOfWeekEnum["MONDAY"] = 1] = "MONDAY";
    DayOfWeekEnum[DayOfWeekEnum["TUESDAY"] = 2] = "TUESDAY";
    DayOfWeekEnum[DayOfWeekEnum["WEDNESDAY"] = 3] = "WEDNESDAY";
    DayOfWeekEnum[DayOfWeekEnum["THURSDAY"] = 4] = "THURSDAY";
    DayOfWeekEnum[DayOfWeekEnum["FRIDAY"] = 5] = "FRIDAY";
    DayOfWeekEnum[DayOfWeekEnum["SATURDAY"] = 6] = "SATURDAY";
})(DayOfWeekEnum = exports.DayOfWeekEnum || (exports.DayOfWeekEnum = {}));
var ActionTypesEnum;
(function (ActionTypesEnum) {
    ActionTypesEnum["CREATE"] = "create";
    ActionTypesEnum["READ"] = "read";
    ActionTypesEnum["UPDATE"] = "update";
    ActionTypesEnum["DELETE"] = "delete";
})(ActionTypesEnum = exports.ActionTypesEnum || (exports.ActionTypesEnum = {}));
var ActionSourcePlatformEnum;
(function (ActionSourcePlatformEnum) {
    ActionSourcePlatformEnum["ADMIN"] = "admin";
    ActionSourcePlatformEnum["BACKOFFICE"] = "backoffice";
    ActionSourcePlatformEnum["CONSUMER"] = "consumer";
})(ActionSourcePlatformEnum = exports.ActionSourcePlatformEnum || (exports.ActionSourcePlatformEnum = {}));
var RolesEnum;
(function (RolesEnum) {
    RolesEnum["ORG_ADMIN"] = "organizationAdmin";
    RolesEnum["BOND_ADMIN"] = "bondAdmin";
})(RolesEnum = exports.RolesEnum || (exports.RolesEnum = {}));
var SeasonPoolStatusEnum;
(function (SeasonPoolStatusEnum) {
    SeasonPoolStatusEnum[SeasonPoolStatusEnum["IN_POOL"] = 5] = "IN_POOL";
    SeasonPoolStatusEnum[SeasonPoolStatusEnum["ASSIGNED"] = 1] = "ASSIGNED";
    SeasonPoolStatusEnum[SeasonPoolStatusEnum["QUIT"] = 2] = "QUIT";
    SeasonPoolStatusEnum[SeasonPoolStatusEnum["SUSPENDED"] = 3] = "SUSPENDED";
    SeasonPoolStatusEnum[SeasonPoolStatusEnum["INACTIVE"] = 4] = "INACTIVE";
})(SeasonPoolStatusEnum = exports.SeasonPoolStatusEnum || (exports.SeasonPoolStatusEnum = {}));
var AmenitiesEnum;
(function (AmenitiesEnum) {
    AmenitiesEnum[AmenitiesEnum["HEAT"] = 1] = "HEAT";
    AmenitiesEnum[AmenitiesEnum["AC"] = 2] = "AC";
    AmenitiesEnum[AmenitiesEnum["WIFI"] = 3] = "WIFI";
    AmenitiesEnum[AmenitiesEnum["RESTROOMS"] = 4] = "RESTROOMS";
    AmenitiesEnum[AmenitiesEnum["DRINKING_FOUNTAIN"] = 5] = "DRINKING_FOUNTAIN";
    AmenitiesEnum[AmenitiesEnum["PARKING"] = 6] = "PARKING";
    AmenitiesEnum[AmenitiesEnum["CONCESSIONS"] = 7] = "CONCESSIONS";
    AmenitiesEnum[AmenitiesEnum["SHELTER"] = 8] = "SHELTER";
    AmenitiesEnum[AmenitiesEnum["PORTABLE_RESTROOMS"] = 9] = "PORTABLE_RESTROOMS";
    AmenitiesEnum[AmenitiesEnum["LIGHTS"] = 10] = "LIGHTS";
    AmenitiesEnum[AmenitiesEnum["LOCKER_ROOM"] = 11] = "LOCKER_ROOM";
    AmenitiesEnum[AmenitiesEnum["PAID_PARKING"] = 12] = "PAID_PARKING";
    AmenitiesEnum[AmenitiesEnum["ACCESSIBLE"] = 13] = "ACCESSIBLE";
})(AmenitiesEnum = exports.AmenitiesEnum || (exports.AmenitiesEnum = {}));
var ResourceSubTypeEnum;
(function (ResourceSubTypeEnum) {
    ResourceSubTypeEnum["COURT"] = "court";
    ResourceSubTypeEnum["FIELD"] = "field";
    ResourceSubTypeEnum["ROOM"] = "room";
    ResourceSubTypeEnum["DIAMOND"] = "diamond";
    ResourceSubTypeEnum["RINK"] = "rink";
    ResourceSubTypeEnum["STUDIO"] = "studio";
    ResourceSubTypeEnum["POOL"] = "pool";
    ResourceSubTypeEnum["BATTING_CAGE"] = "batting cage";
    ResourceSubTypeEnum["SHELTER"] = "shelter";
    ResourceSubTypeEnum["GOLF_SIMULATOR"] = "golf simulator";
})(ResourceSubTypeEnum = exports.ResourceSubTypeEnum || (exports.ResourceSubTypeEnum = {}));
var ResourceTypeEnum;
(function (ResourceTypeEnum) {
    ResourceTypeEnum["SPACE"] = "space";
    ResourceTypeEnum["INSTRUCTOR"] = "instructor";
})(ResourceTypeEnum = exports.ResourceTypeEnum || (exports.ResourceTypeEnum = {}));
var ResourceAgesEnum;
(function (ResourceAgesEnum) {
    ResourceAgesEnum["ADULTS"] = "adults";
    ResourceAgesEnum["CHILDREN"] = "children";
})(ResourceAgesEnum = exports.ResourceAgesEnum || (exports.ResourceAgesEnum = {}));
var SpacePropertiesEnum;
(function (SpacePropertiesEnum) {
    SpacePropertiesEnum["OUTDOOR"] = "outdoor";
    SpacePropertiesEnum["INDOOR"] = "indoor";
})(SpacePropertiesEnum = exports.SpacePropertiesEnum || (exports.SpacePropertiesEnum = {}));
var SurfacesEnum;
(function (SurfacesEnum) {
    SurfacesEnum["GRASS"] = "grass";
    SurfacesEnum["TURF"] = "turf";
    SurfacesEnum["FIELD_TURF"] = "fieldTurf";
    SurfacesEnum["ASTRO_TURF"] = "astroTurf";
    SurfacesEnum["HARDWOOD"] = "hardwood";
    SurfacesEnum["ASPHALT"] = "asphalt";
    SurfacesEnum["SAND"] = "sand";
    SurfacesEnum["ICE"] = "ice";
    SurfacesEnum["SPORT_COURT"] = "sportCourt";
})(SurfacesEnum = exports.SurfacesEnum || (exports.SurfacesEnum = {}));
var RegistrationConstraintPeriodTypeEnum;
(function (RegistrationConstraintPeriodTypeEnum) {
    RegistrationConstraintPeriodTypeEnum["MINUTES"] = "minutes";
    RegistrationConstraintPeriodTypeEnum["DAYS"] = "days";
})(RegistrationConstraintPeriodTypeEnum = exports.RegistrationConstraintPeriodTypeEnum || (exports.RegistrationConstraintPeriodTypeEnum = {}));
var RegistrationWindowStatusEnum;
(function (RegistrationWindowStatusEnum) {
    RegistrationWindowStatusEnum["NOT_OPEN_YET"] = "not_opened_yet";
    RegistrationWindowStatusEnum["OPEN"] = "open";
    RegistrationWindowStatusEnum["CLOSED"] = "closed";
})(RegistrationWindowStatusEnum = exports.RegistrationWindowStatusEnum || (exports.RegistrationWindowStatusEnum = {}));
var RegistrationValidationStatusEnum;
(function (RegistrationValidationStatusEnum) {
    RegistrationValidationStatusEnum["FULL"] = "full";
    RegistrationValidationStatusEnum["OVER_REGISTERED"] = "over registered";
    RegistrationValidationStatusEnum["ALREADY_REGISTERED"] = "registered";
    RegistrationValidationStatusEnum["AVAILABLE"] = "available";
    RegistrationValidationStatusEnum["NOT_OPEN_YET"] = "not opened";
    RegistrationValidationStatusEnum["ALREADY_CLOSED"] = "closed";
    // not open for registration for other reasons
    RegistrationValidationStatusEnum["NO_PRODUCT_FOUND"] = "no-product-found";
})(RegistrationValidationStatusEnum = exports.RegistrationValidationStatusEnum || (exports.RegistrationValidationStatusEnum = {}));
var DiscountMethodsEnum;
(function (DiscountMethodsEnum) {
    DiscountMethodsEnum["PERCENT"] = "percent";
    DiscountMethodsEnum["AMOUNT"] = "amount";
})(DiscountMethodsEnum = exports.DiscountMethodsEnum || (exports.DiscountMethodsEnum = {}));
var UserAuthorizationsTypeEnum;
(function (UserAuthorizationsTypeEnum) {
    UserAuthorizationsTypeEnum["ORGANIZATION"] = "organization";
})(UserAuthorizationsTypeEnum = exports.UserAuthorizationsTypeEnum || (exports.UserAuthorizationsTypeEnum = {}));
var OrganizationLocaleDateEnum;
(function (OrganizationLocaleDateEnum) {
    OrganizationLocaleDateEnum["USA"] = "USA";
})(OrganizationLocaleDateEnum = exports.OrganizationLocaleDateEnum || (exports.OrganizationLocaleDateEnum = {}));
var DateTimeFormatsEnum;
(function (DateTimeFormatsEnum) {
    DateTimeFormatsEnum["API_DATE"] = "YYYY/MM/DD";
    DateTimeFormatsEnum["API_TIME"] = "HH:mm:ss";
    DateTimeFormatsEnum["DB_DATE"] = "YYYY-MM-DD";
})(DateTimeFormatsEnum = exports.DateTimeFormatsEnum || (exports.DateTimeFormatsEnum = {}));
var PlatformsEnum;
(function (PlatformsEnum) {
    PlatformsEnum["CONSUMER"] = "consumer";
    PlatformsEnum["CONSUMER_CHECKOUT"] = "consumer_checkout";
    PlatformsEnum["BO"] = "backoffice";
    PlatformsEnum["MOBILE"] = "mobile";
    PlatformsEnum["CRON"] = "cron";
    PlatformsEnum["IMPORT"] = "import";
    PlatformsEnum["OTHER"] = "other";
})(PlatformsEnum = exports.PlatformsEnum || (exports.PlatformsEnum = {}));
var ShiftStatusEnum;
(function (ShiftStatusEnum) {
    ShiftStatusEnum["OPEN"] = "open";
    ShiftStatusEnum["CLOSED"] = "closed";
    ShiftStatusEnum["MANAGMENT_CLOSED"] = "closed_by_manager";
    ShiftStatusEnum["RECONCILED"] = "reconciled";
})(ShiftStatusEnum = exports.ShiftStatusEnum || (exports.ShiftStatusEnum = {}));
var EventStatusEnum;
(function (EventStatusEnum) {
    EventStatusEnum[EventStatusEnum["OPEN"] = 1] = "OPEN";
    EventStatusEnum[EventStatusEnum["DRAFT"] = 2] = "DRAFT";
    EventStatusEnum[EventStatusEnum["FULL"] = 3] = "FULL";
    EventStatusEnum[EventStatusEnum["CANCELLED"] = 4] = "CANCELLED";
    EventStatusEnum[EventStatusEnum["CLOSED"] = 5] = "CLOSED";
    EventStatusEnum[EventStatusEnum["DELETED"] = 6] = "DELETED";
})(EventStatusEnum = exports.EventStatusEnum || (exports.EventStatusEnum = {}));
var UpdatePricesTypeEnum;
(function (UpdatePricesTypeEnum) {
    UpdatePricesTypeEnum["INDIVIDUAL"] = "individual";
    UpdatePricesTypeEnum["CATEGORY"] = "category";
    UpdatePricesTypeEnum["GLOBAL"] = "global";
})(UpdatePricesTypeEnum = exports.UpdatePricesTypeEnum || (exports.UpdatePricesTypeEnum = {}));
//	The bad way of numbering
var BondDayOfWeekEnum;
(function (BondDayOfWeekEnum) {
    BondDayOfWeekEnum[BondDayOfWeekEnum["MONDAY"] = 2] = "MONDAY";
    BondDayOfWeekEnum[BondDayOfWeekEnum["TUESDAY"] = 3] = "TUESDAY";
    BondDayOfWeekEnum[BondDayOfWeekEnum["WEDNESDAY"] = 4] = "WEDNESDAY";
    BondDayOfWeekEnum[BondDayOfWeekEnum["THURSDAY"] = 5] = "THURSDAY";
    BondDayOfWeekEnum[BondDayOfWeekEnum["FRIDAY"] = 6] = "FRIDAY";
    BondDayOfWeekEnum[BondDayOfWeekEnum["SATURDAY"] = 7] = "SATURDAY";
    BondDayOfWeekEnum[BondDayOfWeekEnum["SUNDAY"] = 8] = "SUNDAY";
})(BondDayOfWeekEnum = exports.BondDayOfWeekEnum || (exports.BondDayOfWeekEnum = {}));
var ProductPackageLevelEnum;
(function (ProductPackageLevelEnum) {
    ProductPackageLevelEnum["HOUR"] = "hour";
    ProductPackageLevelEnum["SLOT"] = "slot";
    ProductPackageLevelEnum["RESERVATION"] = "reservation";
})(ProductPackageLevelEnum = exports.ProductPackageLevelEnum || (exports.ProductPackageLevelEnum = {}));
var CancellationStatusEnum;
(function (CancellationStatusEnum) {
    CancellationStatusEnum["IMMEDIATE"] = "immediate";
    CancellationStatusEnum["AUTO_RENEWAL"] = "auto_renewal";
})(CancellationStatusEnum = exports.CancellationStatusEnum || (exports.CancellationStatusEnum = {}));
var SeasonScheduleStatusEnum;
(function (SeasonScheduleStatusEnum) {
    SeasonScheduleStatusEnum[SeasonScheduleStatusEnum["DRAFT"] = 'draft'] = "DRAFT";
    SeasonScheduleStatusEnum[SeasonScheduleStatusEnum["PUBLISHED"] = 'published'] = "PUBLISHED";
})(SeasonScheduleStatusEnum = exports.SeasonScheduleStatusEnum || (exports.SeasonScheduleStatusEnum = {}));
var FinancialStepEnum;
(function (FinancialStepEnum) {
    FinancialStepEnum["VOID"] = "void";
    FinancialStepEnum["REFUND"] = "refund";
    FinancialStepEnum["NONE"] = "none";
    FinancialStepEnum["REFUND_AND_VOID"] = "refund-and-void";
    FinancialStepEnum["APPEND"] = "append";
})(FinancialStepEnum = exports.FinancialStepEnum || (exports.FinancialStepEnum = {}));
var StripeAccountTypesEnum;
(function (StripeAccountTypesEnum) {
    StripeAccountTypesEnum["STRIPE"] = "stripe";
    StripeAccountTypesEnum["STRIPE_CUSTOM"] = "stripe:account:custom";
    StripeAccountTypesEnum["STRIPE_CUSTOMER"] = "stripe:customer";
})(StripeAccountTypesEnum = exports.StripeAccountTypesEnum || (exports.StripeAccountTypesEnum = {}));
var AddonParentTypeEnum;
(function (AddonParentTypeEnum) {
    AddonParentTypeEnum["RESERVATION"] = "reservation";
    AddonParentTypeEnum["SLOT"] = "slot";
    AddonParentTypeEnum["EVENT"] = "event";
    AddonParentTypeEnum["SESSION"] = "program_session";
    AddonParentTypeEnum["SEGMENT"] = "segment";
})(AddonParentTypeEnum = exports.AddonParentTypeEnum || (exports.AddonParentTypeEnum = {}));
var EEmailStatus;
(function (EEmailStatus) {
    EEmailStatus["SENT"] = "sent";
    EEmailStatus["OPENED"] = "opened";
    EEmailStatus["PAID"] = "paid";
    EEmailStatus["CANCELED"] = "canceled";
})(EEmailStatus = exports.EEmailStatus || (exports.EEmailStatus = {}));
var PaymentSettingStatusEnum;
(function (PaymentSettingStatusEnum) {
    PaymentSettingStatusEnum[PaymentSettingStatusEnum["ENABLED"] = 1] = "ENABLED";
    PaymentSettingStatusEnum[PaymentSettingStatusEnum["DISABLED_REDIRECT"] = 2] = "DISABLED_REDIRECT";
    PaymentSettingStatusEnum[PaymentSettingStatusEnum["DISABLED_INFO_ONLY"] = 3] = "DISABLED_INFO_ONLY";
    PaymentSettingStatusEnum[PaymentSettingStatusEnum["DISABLED_EMAIL"] = 4] = "DISABLED_EMAIL";
})(PaymentSettingStatusEnum = exports.PaymentSettingStatusEnum || (exports.PaymentSettingStatusEnum = {}));
var NotifyMethodEnum;
(function (NotifyMethodEnum) {
    NotifyMethodEnum["EMAIL"] = "Email";
})(NotifyMethodEnum = exports.NotifyMethodEnum || (exports.NotifyMethodEnum = {}));
var EComparisonFilter;
(function (EComparisonFilter) {
    EComparisonFilter["LessThan"] = "lt";
    EComparisonFilter["GreaterOrEqualTo"] = "gte";
})(EComparisonFilter = exports.EComparisonFilter || (exports.EComparisonFilter = {}));
var EmailTemplatesEnum;
(function (EmailTemplatesEnum) {
    EmailTemplatesEnum["PAYMENT_REQUEST_USER"] = "payment_request_user";
    EmailTemplatesEnum["SEND_INVOICE_TO_USER"] = "send_invoice_to_user";
    EmailTemplatesEnum["INVOICE_PUBLISHED"] = "invoice_published";
    EmailTemplatesEnum["INVITE_CUSTOMER"] = "invite_customer";
    EmailTemplatesEnum["INVITE_EMPLOYEE"] = "invite_employee";
    EmailTemplatesEnum["PAUSE_RESUME_USER"] = "pause_resume_user";
    EmailTemplatesEnum["PAUSE_RESUME_ADMIN"] = "pause_resume_admin";
    EmailTemplatesEnum["PAUSE_USER"] = "pause_user";
    EmailTemplatesEnum["ADMIN_PAUSE_USER"] = "admin_pause_user";
    EmailTemplatesEnum["BOOKING_CONFIRMATION_CONSUMER"] = "booking_confirmation_consumer";
    EmailTemplatesEnum["BOOKING_CONFIRMATION_ADMIN"] = "booking_confirmation_admin";
})(EmailTemplatesEnum = exports.EmailTemplatesEnum || (exports.EmailTemplatesEnum = {}));
var ActivityEnum;
(function (ActivityEnum) {
    ActivityEnum["ACTIVE"] = "active";
    ActivityEnum["INACTIVE"] = "inactive";
})(ActivityEnum = exports.ActivityEnum || (exports.ActivityEnum = {}));
var PromiseStatusEnum;
(function (PromiseStatusEnum) {
    PromiseStatusEnum["FULFILLED"] = "fulfilled";
    PromiseStatusEnum["REJECTED"] = "rejected";
})(PromiseStatusEnum = exports.PromiseStatusEnum || (exports.PromiseStatusEnum = {}));
var PriceFieldEnum;
(function (PriceFieldEnum) {
    PriceFieldEnum["PRICE"] = "price";
    PriceFieldEnum["TOTAL_PRICE"] = "totalPrice";
    PriceFieldEnum["AMOUNT"] = "amount";
    PriceFieldEnum["PAID_AMOUNT"] = "paidAmount";
    PriceFieldEnum["FEE_AMOUNT"] = "feeAmount";
    PriceFieldEnum["REFUND_AMOUNT"] = "refundAmount";
    PriceFieldEnum["DISCOUNT_AMOUNT"] = "discountAmount";
    PriceFieldEnum["DISPLAY_FULL_PRICE"] = "displayFullPrice";
    PriceFieldEnum["DISPLAY_TOTAL_PRICE_WITH_TAX"] = "displayTotalPriceWithTax";
})(PriceFieldEnum = exports.PriceFieldEnum || (exports.PriceFieldEnum = {}));
var MembershipFilterByPropertyEnum;
(function (MembershipFilterByPropertyEnum) {
    MembershipFilterByPropertyEnum["MEMBERSHIP_STATUS"] = "membershipStatus";
    MembershipFilterByPropertyEnum["PAYMENT_STATUS"] = "paymentStatus";
    MembershipFilterByPropertyEnum["RENEWAL_TYPE"] = "renewalType";
})(MembershipFilterByPropertyEnum = exports.MembershipFilterByPropertyEnum || (exports.MembershipFilterByPropertyEnum = {}));
var MembershipOrderByPropertyEnum;
(function (MembershipOrderByPropertyEnum) {
    MembershipOrderByPropertyEnum["STARTDATE"] = "startDate";
    MembershipOrderByPropertyEnum["ENDDATE"] = "endDate";
    MembershipOrderByPropertyEnum["MEMBERSHIP"] = "membership";
    MembershipOrderByPropertyEnum["NAME"] = "name";
    MembershipOrderByPropertyEnum["MEMBERSHIP_STATUS"] = "membershipStatus";
    MembershipOrderByPropertyEnum["PRICE"] = "price";
    MembershipOrderByPropertyEnum["PAYMENT_STATUS"] = "paymentStatus";
    MembershipOrderByPropertyEnum["RENEWAL"] = "renewal";
})(MembershipOrderByPropertyEnum = exports.MembershipOrderByPropertyEnum || (exports.MembershipOrderByPropertyEnum = {}));
var OrderByEnum;
(function (OrderByEnum) {
    OrderByEnum["ASC"] = "ASC";
    OrderByEnum["DESC"] = "DESC";
})(OrderByEnum = exports.OrderByEnum || (exports.OrderByEnum = {}));
var SignWaiverEnum;
(function (SignWaiverEnum) {
    SignWaiverEnum["SIGNED"] = "signed";
    SignWaiverEnum["UNSIGNED"] = "unsigned";
})(SignWaiverEnum = exports.SignWaiverEnum || (exports.SignWaiverEnum = {}));
var EProductResourceSettingKey;
(function (EProductResourceSettingKey) {
    EProductResourceSettingKey["HIDE_PUNCHPASS_SCHEDULE"] = "isHidePunchPassSchedule";
    EProductResourceSettingKey["HIDE_ALL_QUANTITY_SCHEDULE"] = "isHideAllQuantitySchedule";
    EProductResourceSettingKey["HIDE_CONSUMER_PRODUCT"] = "isHideConsumerProduct";
})(EProductResourceSettingKey = exports.EProductResourceSettingKey || (exports.EProductResourceSettingKey = {}));
var MonthsEnum;
(function (MonthsEnum) {
    MonthsEnum["JANUARY"] = "January";
    MonthsEnum["FEBRUARY"] = "February";
    MonthsEnum["MARCH"] = "March";
    MonthsEnum["APRIL"] = "April";
    MonthsEnum["MAY"] = "May";
    MonthsEnum["JUNE"] = "June";
    MonthsEnum["JULY"] = "July";
    MonthsEnum["AUGUST"] = "August";
    MonthsEnum["SEPTEMBER"] = "September";
    MonthsEnum["OCTOBER"] = "October";
    MonthsEnum["NOVEMBER"] = "November";
    MonthsEnum["DECEMBER"] = "December";
})(MonthsEnum = exports.MonthsEnum || (exports.MonthsEnum = {}));
var QuantityOperationsEnum;
(function (QuantityOperationsEnum) {
    QuantityOperationsEnum["INCREMENT"] = "increment";
    QuantityOperationsEnum["DECREMENT"] = "decrement";
})(QuantityOperationsEnum = exports.QuantityOperationsEnum || (exports.QuantityOperationsEnum = {}));
var TimeUnitsEnum;
(function (TimeUnitsEnum) {
    TimeUnitsEnum["MILLISECOND"] = "millisecond";
    TimeUnitsEnum["SECOND"] = "second";
    TimeUnitsEnum["MINUTE"] = "minute";
    TimeUnitsEnum["HOUR"] = "hour";
    TimeUnitsEnum["DAY"] = "day";
    TimeUnitsEnum["WEEK"] = "week";
    TimeUnitsEnum["MONTH"] = "month";
    TimeUnitsEnum["YEAR"] = "year";
})(TimeUnitsEnum = exports.TimeUnitsEnum || (exports.TimeUnitsEnum = {}));
var PaginationTypeEnum;
(function (PaginationTypeEnum) {
    PaginationTypeEnum["OFFSET"] = "offset";
    PaginationTypeEnum["PAGE"] = "page";
})(PaginationTypeEnum = exports.PaginationTypeEnum || (exports.PaginationTypeEnum = {}));
var ErrorKeysEnum;
(function (ErrorKeysEnum) {
    ErrorKeysEnum["CUSTOMER_EMAIL_EXISTS"] = "customer_email_exists";
})(ErrorKeysEnum = exports.ErrorKeysEnum || (exports.ErrorKeysEnum = {}));
//# sourceMappingURL=enums.service.js.map